module.exports = __webpack_public_path__ + "img/fr.78e9f99b.png";